<template>
  <div class="detail-content" :class="[{pc: !mobile}, {mb: mobile}]">
    <template v-if="!loading">
      <!-- Heading -->
      <template v-if="!mobile">
        <div class="title" v-if="!loading">
          <img src="/static/images/icon-st.jpg" />
          <span>{{outlineInfo.courseName}}</span>
        </div>
      </template>
      <template v-if="mobile">
        <div v-if="!loading" class="title_mb">
          <span>{{outlineInfo.courseName}}</span>
        </div>
      </template>
      <!-- end heading -->

      <!-- Title -->
      <div class="top">
        <div class="title title__exam">
          <div :class="!mobile ? 'title__btn--left' : 'btn-next-1'" @click="back()">
            <img src="/static/images/icon-back-1.png" alt="icon-back-1" />
            <label v-if="!mobile">{{$t('common.returnButton')}}</label>
          </div>
          <div v-if="mobile" class="title__btn--left">
            <div v-if="curriculumInfo.isCovenantShow != 0" @click="covenant()">
              <img src="/static/images/icon-ck.png" alt="icon-ck" />
              <label>{{$t('curriculum.covenant')}}</label>
            </div>
          </div>
          <h2>{{$t('curriculumExam.listExam')}}</h2>
          <div class="title__btn--right">
            <div v-if="(curriculumInfo.externalLink != null || curriculumInfo.isQuestionnaireShow != 0) && mobile" @click="questionnaire()">
              <img src="/static/images/icon-kx.png" alt="icon-kx" />
              <label>{{$t('curriculum.question')}}</label>
            </div>
          </div>
        </div>
      </div>
      <!-- end title -->

      <div class="content">

        <!-- content exam -->
        <div :class="mobile ? 'curr-exam__content__item curr-exam__content__mobile': 'curr-exam__content__item'">
          <div class="curr-exam__content__item__inner" v-for="(item, index) in listMidterm" :key="item.id">
              <div class="tooltip">
                <div class="curr-exam__name ">
                  <div class="buttons" >
                    <button @click="midTermExam(index, item)" class="draw " >
                        <p>{{item.examName}}</p>
                    </button>
                  </div>
                </div>
                <span class="tooltiptext" v-if="item.examName.length > 45" >{{item.examName}}</span>
              </div>
              <div v-if="!mobile" class="curr-exam__progress" @click="detailExam(item)">
                <el-progress 
                  :color="setColor(item.isPass)"
                  :format="formatsProgress(item)"
                  :text-inside="true"
                  :stroke-width="20"
                  :percentage="item.progress">
                </el-progress>
              </div>
              <div class="curr-exam__summary">
                <div class="curr-exam__summary__inner">
                  <div v-if="item.recentScore == '--' || parseInt(item.status) == $CONST.CURRICULUM_EXAM.STATUS.MIDTERM.GRADING" class="curr-exam__no__summary">
                    <p>ー</p>
                  </div>
                  <template v-else>
                    <div class="btn__detail" @click="detailExam(item)">
                      <p>{{$t('comments.detail')}}</p>
                    </div>
                  </template>
                </div>
              </div>
          </div>
          <div class="curr-exam__content__item__inner" v-if="examInfo.passMarks != null">
            <div class="curr-exam__name btn__final-exam">
              <div class="buttons" @click="exam()">
                <button class="draw"><p>{{$t('scoreStatistics.finalExam')}}</p></button>
              </div>
            </div>
            <div v-if="!mobile" class="curr-exam__progress" @click="detailExam(examInfo)">
              <el-progress 
                :color="setColor(examInfo.isPass)"
                :format="formatsProgress(examInfo)"
                :text-inside="true"
                :stroke-width="26"
                :percentage="examInfo.progress">
              </el-progress>
            </div>
            <div class="curr-exam__summary">
              <div class="curr-exam__summary__inner">
                <div v-if="(examInfo.recentScore == '--') || (parseInt(examInfo.status) == $CONST.CURRICULUM_EXAM.STATUS.MIDTERM.GRADING)" class="curr-exam__no__summary">
                  <p>ー</p>
                </div>
                <template v-else>
                  <div class="btn__detail" @click="detailExam(examInfo)">
                    <p>{{$t('comments.detail')}}</p>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <!-- content button statistic and finish course -->
          <div class="curr-btn__content">
            <button class="btn__back" v-if="!mobile" @click="back()">
              <p>{{$t('common.returnButton')}}</p>
            </button>
            <button class="btn__analysis" @click="scoreStatistics()">
              <img src="/static/images/icon-tt.png" alt="icon-tt" />
              <p>{{$t('curriculum.scoreStatistics')}}</p>
            </button>
            <button class="btn__analysis" v-if="curriculumInfo.isCovenantShow != 0 && !mobile" @click="covenant()">
              <img src="/static/images/icon-ck.png" alt="icon-ck" />
              <p>{{$t('curriculum.covenant')}}</p>
            </button>
            <button class="btn__analysis" v-if="(curriculumInfo.externalLink != null || curriculumInfo.isQuestionnaireShow != 0) && !mobile" @click="questionnaire()">
              <img src="/static/images/icon-kx.png" alt="icon-kx" />
              <p>{{$t('curriculum.question')}}</p>
            </button>
            <button @click="downLoad(outlineInfo.courseId, outlineInfo.courseName)" v-if="parseInt(curriculumInfo.isFinished) == 1" class="btn__back">
              <p>{{$t('studySituationList.certificate')}}</p>
            </button>
            <button
              v-else
              :class="curriculumInfo.isShowStep1 == 1 && curriculumInfo.isShowStep2 == 1 && curriculumInfo.isShowStep3 == 1 && curriculumInfo.isShowStep4 == 1 && curriculumInfo.isShowStep5 == 1 && parseInt(curriculumInfo.isFinished) == 0 ? 'btn__finish' : 'btn__disable'"
              :disabled="(curriculumInfo.isShowStep1 != 1 || curriculumInfo.isShowStep2 != 1 || curriculumInfo.isShowStep3 != 1 || curriculumInfo.isShowStep4 != 1 || curriculumInfo.isShowStep5 != 1) && parseInt(curriculumInfo.isFinished) == 0"
              @click="finishCourse()"
            >
              <p>{{$t('manual.endCourse')}}</p>
            </button>
          </div>
          <!-- end content button statistic and finish course -->

          <!-- content rank of course -->
          <div class="content__statistic">
            <div class="content__rank">
              <div class="content__rank__title">
                <img src="/static/images/congratulation/bg-rank.png" alt="bg-rank" />
                <h3>{{$t('curriculumExam.rank')}}</h3>
              </div>
              <div class="content__rank__info">
                <template v-if="listRanks.length">
                  <div class="content__rank__inner" v-for="(item, index) in listRanks" :key="index">
                    <div class="content__rank__icon">
                      <img v-if="index == 0" :src="firstRankIcon" alt="rank icon" />
                      <img v-else-if="index == 1" :src="secondRankIcon" alt="rank icon" />
                      <img v-else-if="index == 2" :src="thirdRankIcon" alt="rank icon" />
                      <p v-else>{{index + 1}}</p>
                    </div>
                    <div class="content__rank__name">
                      <p>{{item.name}}</p>
                    </div>
                    <div class="content__rank__score">
                      <p>{{item.score + ' ' + $t('scoreStatistics.message2')}}</p>
                    </div>
                  </div>
                </template>
                <div v-else class="content__rank__noResult">
                  <img src="/static/images/noresult.jpg" alt="no result" />
                </div>
              </div>
            </div>
          </div>
          <!-- end content rank of course -->
        </div>
        <!-- end content exam -->
      </div>
    </template>

    <!-- Loading -->
    <loading :showLoading="loading" />
    <!-- end loading -->
  </div>
</template>

<script>
  import { mapState } from "vuex";
  import loading from "@/components/loading/loading";
  import chartCurriculumExam from "@/components/curriculum/chartCurriculumExam";
  import md5 from "js-md5";

  export default {
    data() {
      return {
        loading: false,
        userId: window.sessionStorage.getItem("id"),
        outlineInfo: eval("(" + this.$route.query.outlineInfo + ")"),
        listMidterm: [],
        listRanks: [],
        curriculumInfo: {},
        examInfo: {},
        passExam: 0,
        failExam: 0,
        notDoneExam: 0,
        firstRankIcon: "/static/images/congratulation/first-rank.png",
        secondRankIcon: "/static/images/congratulation/second-rank.png",
        thirdRankIcon: "/static/images/congratulation/third-rank.png",
        isDoing: false,
      };
    },
    components: {
      loading,
      chartCurriculumExam,
    },
    computed: {
      // get data from store
      ...mapState({
        mobile: (state) => state.header.mobile,
      }),
    },
    created() {
      this.$autoLogin().then(
        () => {
          this.init();
        },
        () => {
          this.$router.push({
            path: "/home",
          });
        }
      );
    },
    methods: {
      async init() {
        this.loading = true;
        this.listMidterm = await this.getExamList();
        let isMidtermDoing = this.listMidterm.filter((item) => item.status == 1);
        this.isDoing = isMidtermDoing.length ? true : false;
        this.curriculumInfo = await this.getCurriculumInfo();
        this.examInfo = await this.getExamInfo();
        this.listRanks = await this.getListRank();
        this.loading = false;
      },

      // Get list of rank
      getListRank() {
        return new Promise((resolve, reject) => {
          this.$api
            .post("/evaluate/getHighEvaluteStudents", {
              courseId: this.outlineInfo.courseId,
              limit: 10,
            })
            .then((response) => {
              resolve(response.data);
            })
            .catch((err) => {
              reject(err.response);
            });
        });
      },

      // Finish course
      finishCourse() {
        this.$confirm(window.vm.$i18n.t("new.title35"), window.vm.$i18n.t("js.hint"), {
          distinguishCancelAndClose: true,
          confirmButtonText: window.vm.$i18n.t("js.confirm"),
          cancelButtonText: window.vm.$i18n.t("js.cancel"),
          cancelButtonClass: "btn-custom-cancel",
        })
          .then(() => {
            this.$api
              .post("/courseStudy/updatecourseFinished", {
                courseId: this.outlineInfo.courseId,
              })
              .then((response) => {
                this.curriculumInfo = response.data;
                this.$message.warning(window.vm.$i18n.t("new.title36"));
              });
            this.init();
          })
          .catch(() => {});
      },

      // handle go to exam
      exam() {
        let exams = this.listMidterm;
        let statusMidTerm = exams.some((item) => item.status == 1);
        if (statusMidTerm) {
          this.$message.warning(this.$i18n.t("new.title98"));
          return;
        }
        if (parseInt(this.curriculumInfo.isFinished) == 1) {
          this.$message.warning(this.$i18n.t("new.title21"));
          return;
        }
        if (parseInt(this.curriculumInfo.isLocked) == 0) {
          this.$message.warning(this.$i18n.t("new.title81"));
          return;
        }
        if (parseInt(this.curriculumInfo.isExamClick) == 2) {
          this.$message.warning(this.$i18n.t("js.examDataNone"));
          return;
        }
        let statusMidTermHt = exams.some((item) => item.status == 2);
        if (parseInt(this.curriculumInfo.isExamClick) == 3 || statusMidTermHt) {
          this.$message.warning(this.$i18n.t("js.nocorrect"));
          return;
        }
        this.$router.push({
          path: "exam/begins",
          query: {
            courseId: this.outlineInfo.courseId,
            courseName: this.outlineInfo.courseName,
            redirect: false,
            examFlag: this.outlineInfo.examFlag,
            isCurriculumExam: true,
          },
        });
      },

      // handle go to midterm exam
      midTermExam(index, items) {
        const statusGrading = this.$CONST.CURRICULUM_EXAM.STATUS.MIDTERM.GRADING;
        const statusNotStartOrSuccess = this.$CONST.CURRICULUM_EXAM.STATUS.MIDTERM.NOT_START_OR_SUCCESS;
        const grading = this.listMidterm.filter((item) => parseInt(item.status) == this.$CONST.CURRICULUM_EXAM.STATUS.MIDTERM.GRADING);
        if ((this.isDoing && parseInt(items.status) == statusNotStartOrSuccess) || (this.isDoing && parseInt(items.status) == statusGrading)) {
          this.$message.warning(window.vm.$i18n.t("new.title101"));
          return;
        }
        if (parseInt(this.outlineInfo.examFlag) == this.$CONST.CURRICULUM_EXAM.STATUS.MIDTERM.GRADING) {
          this.$message.warning(this.$i18n.t("new.title97"));
          return;
        }
        if (grading.length) {
          const isExamGrading = grading.some(item => item.examId == items.examId);
          if (isExamGrading) {
            this.$message.warning(this.$i18n.t("js.nocorrect"));
            return;
          }
        }
        this.$router.push({
          path: "exam/mid_term",
          query: {
            courseId: this.outlineInfo.courseId,
            courseName: this.outlineInfo.courseName,
            redirect: false,
            examFlag: this.outlineInfo.examFlag,
            index: index,
            isCurriculumExam: true,
          },
        });
      },

      // get list mid term
      getExamList() {
        const self = this;
        return new Promise((resolve, reject) => {
          this.$api
            .post("/courseStudy/getExamList", {
              courseId: this.outlineInfo.courseId,
            })
            .then((response) => {
              Promise.all(response.data).then(() => {
                response.data.forEach((el) => {
                  self.$api
                    .post("/studyCourseQuestion/getPastExamInfo", {
                      courseId: this.outlineInfo.courseId,
                      examId: el.examId,
                    })
                    .then((res) => {
                      el['isTemp'] = res.data.isTemp != null ? parseInt(res.data.isTemp) : res.data.isTemp,
                      el['maxScore'] = res.data.maxScore != null && res.data.recentScore != '--' ? parseInt(res.data.maxScore) : '--',
                      el['passMarks'] = res.data.passMarks != null ? parseInt(res.data.passMarks) : res.data.passMarks,
                      el['recentScore'] = res.data.recentScore != null && res.data.recentScore != '--' ? parseInt(res.data.recentScore) : '--',
                      el['isCommit'] = res.data.recentScore == '--' ? true : false,
                      el['restCount'] = res.data.restCount != null ? parseInt(res.data.restCount) : res.data.restCount,
                      el['fullMarks'] = res.data.fullMarks != null ? parseInt(res.data.fullMarks) : res.data.fullMarks,
                      res.data.recentScore != null && res.data.recentScore != '--' && res.data.fullMarks != null ? res.data.fullMarks != 0 ? el['progress'] = Number((parseInt(res.data.recentScore) / parseInt(res.data.fullMarks) * 100).toFixed()) : el['progress'] = 100 : el['progress'] = 0,
                      res.data.recentScore != null && res.data.recentScore != '--' && res.data.fullMarks != null ? el['isPass'] = res.data.recentScore >= res.data.passMarks ?  true : false : el['isPass'] = false;
                      res.data.recentScore != null && res.data.recentScore != '--' ? el.isPass ? self.passExam += 1 : self.failExam +=1 : self.notDoneExam += 1
                    });
                });
                resolve(response.data.sort((a, b) => a.examName.localeCompare(b.examName, 'en', { numeric: true })) || []);
              });
            })
            .catch((err) => {
              reject(err.response);
            });
        });
      },

      // get info of exam
      getExamInfo() {
        const self = this;
        return new Promise((resolve, reject) => {
          self.$api
            .post("/studyCourseQuestion/getPastExamInfo", {
              courseId: this.outlineInfo.courseId,
            })
            .then((response) => {
              let result = {
                isTemp: response.data.isTemp != null ? parseInt(response.data.isTemp) : response.data.isTemp,
                maxScore: response.data.maxScore != null && response.data.recentScore != '--' ? parseInt(response.data.maxScore) : '--',
                passMarks: response.data.passMarks != null ? parseInt(response.data.passMarks) : response.data.passMarks,
                recentScore: response.data.recentScore != null && response.data.recentScore != '--' ? parseInt(response.data.recentScore) : '--',
                isCommit: response.data.recentScore == '--' ? true : false,
                restCount: response.data.restCount != null ? parseInt(response.data.restCount) : response.data.restCount,
                fullMarks: response.data.fullMarks != null ? parseInt(response.data.fullMarks) : response.data.fullMarks,
                progress: response.data.recentScore != null && response.data.recentScore != '--' && response.data.fullMarks != null ? response.data.fullMarks != 0 ? Number((parseInt(response.data.recentScore) / parseInt(response.data.fullMarks) * 100).toFixed()) : 100 : 0,
                isPass: response.data.recentScore != null && response.data.recentScore != '--' && response.data.fullMarks != null ? parseInt(response.data.recentScore) >= parseInt(response.data.passMarks) ?  true : false : false
              }
              result.recentScore != null && result.recentScore != '--' ? result.isPass ? self.passExam += 1 : self.failExam += 1 : self.notDoneExam += 1;
              resolve(result);
            })
            .catch((err) => {
              reject(err.response);
            });
        });
      },

      // handle go to detail exam
      detailExam(params) {
        if (params.recentScore == '--') {
          this.$message.warning(window.vm.$i18n.t("new.title26"));
          return
        }
        if (parseInt(params.status) == this.$CONST.CURRICULUM_EXAM.STATUS.MIDTERM.GRADING) {
          this.$message.warning(window.vm.$i18n.t("new.title27"));
          return
        }
        if (parseInt(params.status) == this.$CONST.CURRICULUM_EXAM.STATUS.MIDTERM.DOING) {
          this.$message.warning(window.vm.$i18n.t("curriculumExam.doingExam"));
          return
        }
        this.$router.push({
          path: "exam/detailExam",
          query: {
            courseId: this.outlineInfo.courseId,
            examId: params.examId || null,
            isCurriculumExam: true,
          },
        });
      },

      // handle go to statistics
      async scoreStatistics() {
        let statistics = await this.getSingleCourseScoreStatistics({ id: this.outlineInfo.courseId });
        if (statistics.length == 0) {
          this.$message.warning(window.vm.$i18n.t("new.title26"));
          return;
        }
        if (this.curriculumInfo.isScoreStatistics == 0) {
          this.$message.warning(window.vm.$i18n.t("new.title27"));
          return;
        }
        this.$router.push({
          path: "exam/scoreStatistics",
          query: {
            courseId: this.outlineInfo.courseId,
            courseName: this.outlineInfo.courseName,
            num: 2,
            isCurriculumExam: true,
          },
        });
      },

      // get list statistic of course
      getSingleCourseScoreStatistics: function (data) {
        return new Promise((resolve, reject) => {
          this.$api
            .post("/home/getsingleCourseScoreStatistics", {
              courseId: data.id,
              languageType: this.$lang(),
            })
            .then((response) => {
              resolve(response.data || []);
            })
            .catch((err) => {
              reject(err.response);
            });
        });
      },

      // get curriculum info
      getCurriculumInfo: function () {
        return new Promise((resolve, reject) => {
          this.$api
            .post("/courseStudy/getCurriculumInfo", {
              courseId: this.outlineInfo.courseId,
            })
            .then((response) => {
              resolve(response.data);
            })
            .catch((err) => {
              reject(err.response);
            });
        });
      },

      // Show questionnaire
      questionnaire() {
        if (this.curriculumInfo.externalLink != null) {
          window.open(this.curriculumInfo.externalLink);
        } else {
          if (this.curriculumInfo.isShowStep3 != 1) {
            this.$message.warning(window.vm.$i18n.t("js.jumpToQuestion"));
            return;
          }
          if (this.curriculumInfo.isShowStep5 != 1) {
            this.$message.warning(window.vm.$i18n.t("new.title46"));
            return;
          }
          if (this.curriculumInfo.isShowStep1 == 1 && this.curriculumInfo.isShowStep2 == 1 && this.curriculumInfo.isShowStep3 == 1 && this.curriculumInfo.isShowStep5 == 1) {
            this.$router.push({
              path: "exam/covenant",
              query: {
                courseId: this.outlineInfo.courseId,
                courseName: this.outlineInfo.courseName,
                templateType: 1,
                type: 1,
                isCurriculumExam: true,
              },
            });
          }
        }
      },

      // show covenant
      covenant: function () {
        if (this.curriculumInfo.isShowStep2 != 1) {
          this.$message.warning(window.vm.$i18n.t("new.title49"));
          return;
        }
        if (this.curriculumInfo.isShowStep3 != 1) {
          this.$message.warning(window.vm.$i18n.t("new.title48"));
          return;
        }
        if (this.curriculumInfo.isShowStep1 == 1 && this.curriculumInfo.isShowStep2 == 1 && this.curriculumInfo.isShowStep3 == 1) {
          this.$router.push({
            path: "exam/covenant",
            query: {
              courseId: this.outlineInfo.courseId,
              courseName: this.outlineInfo.courseName,
              templateType: 0,
              type: 2,
              isCurriculumExam: true,
            },
          });
        }
      },

      // format for item progress exam
      formatsProgress(params) {
        return () => {
          if (params.recentScore != null && params.recentScore != "--" && params.status != this.$CONST.CURRICULUM_EXAM.STATUS.MIDTERM.GRADING) {
            return " ( " + params.recentScore + " / " + params.fullMarks + " ) " + params.progress + "%";
          }
          return "0%";
        };
      },

      // set color for item progress exam
      setColor(params) {
        if (params) {
          return "#2ed573";
        }
        return "#ff4757";
      },

      // get information of user
      getInfoUser() {
          return new Promise((resolve, reject) => {
              this.showLoadingFlg = true;
              this.$api
              .post("/personalCenter/getPersonalInfo", {
                  rToken:md5(window.sessionStorage.getItem("email")),
                  languageType:this.$lang(),
              })
              .then((response) => {
                  resolve(response.data)
              })
              .catch((err) => {
                  reject(err.response);
              });
          });
      },

      // download certificate
      async downLoad(courseId, courseName) {
        const userInfo = await this.getInfoUser();
        this.$api
          .post("/home/certificateExport", {
            id: courseId,
            courseName: courseName,
            courseLanguage: this.$lang(),
            area: this.$lang(),
            name: userInfo.userName,
            gender: userInfo.gender,
            companyId: window.sessionStorage.getItem("companyId"),
            jobs: userInfo.job
          })
          .then((response) => {
            if (response.data != null) {
              window.open(response.data);
            } else {
              this.$message.warning(window.vm.$i18n.t("js.certificateDataNone"));
            }
          })
          .catch((error) => {
          });
      },

      // back to Aicourse
      back() {
        this.$router.push({
          name: "Aicourse",
          query: {
            buyCourseId: this.outlineInfo.courseId,
          },
        });
      },
    },
  };
</script>

<style scoped>
  .top {
    margin-top: 30px;
  }
  .title h2 {
    margin: 0 auto;
  }
  .title__btn--left {
    cursor: pointer;
    display: none;
  }
  .title__btn--left img {
    margin: 0 auto 3px auto;
  }
  .title__btn--left label {
    cursor: pointer;
  }
  .title__btn--left:hover {
    opacity: 0.7;
  }
  .content {
    height: auto;
    width: 80%;
    justify-content: center;
    margin: 0 auto;
  }
  /* item exam */
  .curr-exam__content__item {
    width: 100%;
  }
  .curr-exam__content__item__inner {
    display: flex;
    margin-bottom: 30px;
    align-items: center;
    column-gap: 10px;
  }
  .curr-exam__name {
    display: flex;
    align-items: center;
    column-gap: 5px;
    width: 300px;
  }
  .curr-exam__name:hover {
    opacity: 0.7;
    cursor: pointer;
    color: #0071c5;
  }
  .curr-exam__name img {
    width: 24px;
  }
  .curr-exam__name p {
    font-size: 14px;
    font-weight: 600;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    line-clamp: 1;
    -webkit-line-clamp: 1;
  }
  .curr-exam__progress {
    width:  calc(100% - 390px);
  }
  
  .curr-exam__progress:hover {
    cursor: pointer;
    opacity: 0.7;
  }
  .curr-exam__summary {
    display: flex;
    width: max-content;
    align-items: center;
  }
  .curr-exam__summary__inner {
    display: flex;
    justify-content: space-around;
    width: 100%;
  }
  .curr-exam__summary__inner p {
    font-size: 14px;
    line-height: 22px;
    width: 90px;
    text-align: center;
    font-weight: bold;
  }
  .curr-exam__summary__status__fail {
    color: #FF0707;
    border: 2px solid #FF0707;
    border-radius: 10px;
    cursor: pointer;
  }
  .curr-exam__summary__status__fail:hover {
    opacity: 0.7;
  }
  .curr-exam__summary__fail__mark {
    color: #FF0707;
    margin: auto 0;
  }
  .curr-exam__summary__status__pass {
    color: #69c568;
    border: 2px solid #69c568;
    border-radius: 10px;
    cursor: pointer;
  }
  .curr-exam__summary__status__pass:hover {
    opacity: 0.7;
  }
  .curr-exam__summary__pass__mark {
    color: #69c568;
    margin: auto 0;
  }
  .curr-exam__no__summary p {
    color: #0071c5;
    font-size: 20px !important;
  }
  /* end item exam */

  /* button exam */
  .curr-btn__content {
    display: flex;
    column-gap: 10px;
    justify-content: center;
    margin: 30px;
  }
  .curr-btn__content img {
    width: 25px;
  }
  .curr-btn__content button {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: bold;
    line-height: 30px;
    border-radius: 10px;
    width: 150px;
    justify-content: center;
    column-gap: 5px;
  }
  .curr-btn__content button:hover {
    opacity: 0.7;
  }
  .btn__final-exam {
    color: #0071c5;
    border: none;
  }
  .btn__analysis {
    color: #0071c5;
    border: 2px solid #0071c5;
    background-color: #ffffff;
  }
  .btn__finish {
    background: #2ED573;
    border: 2px solid #2ED573;
    color: #ffffff;
  }
  .btn__detail {
    background: #0071c5;
    color: #ffffff;
    border-radius: 10px;
    height: 26px;
  }
  .btn__detail p {
    height: 100%;
    line-height: 26px;
  }
  .btn__detail:hover {
    opacity: 0.7;
    cursor: pointer;
  }
  .btn__disable {
    background: #d3d3d3;
    color: #ffffff;
    cursor: not-allowed;
    border: none;
  }
  .btn__disable:hover {
    opacity: unset !important;
  }
  .btn__back {
    color: #ffffff;
    border: 2px solid #0071c5;
    background-color: #0071c5;
  }

  /* tooltip */
  
  .tooltip{
    position: relative;
    display: inline-block;
  }
  .tooltip .buttons{
    z-index: 1;
  }
  
  .tooltip .tooltiptext{
    position: absolute;
    z-index: 2;
    visibility: hidden;
    height: auto;
    max-width: 100%;
    margin-top: 5px;
    margin-left: -150px;
    background-color: #000000;
    color: #ffffff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 10px 5px 10px;
    bottom: 120%;
    left: 50%;
    opacity: 0;
    transition: opacity 2s;
    word-wrap: break-word;
  }
  .tooltip .tooltiptext::after{
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #000000 transparent transparent transparent;
  }
  .tooltip:hover .tooltiptext{
    visibility: visible;
    opacity: 1;
  }
  /* end tooltip */

  .buttons button {
    background: none;
    box-sizing: border-box;
    border: none;
    margin: 0;
    padding: 10px;
    color: #000000;
    font-size: 15px;
    font-weight: 700;
    position: relative;
    vertical-align: middle;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    line-clamp: 1;
    -webkit-line-clamp: 1;
    border-radius: 5px;
  }
  .buttons button::before,
  .buttons button::after {
    box-sizing: inherit;
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
  
  .buttons .draw p {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    line-clamp: 1;
    -webkit-line-clamp: 1;
    width: 300px;
    text-align: left;
  }
  
  .buttons .draw {
    transition: color 0.25s;
    width: 100%;
  }
  .buttons .draw::before,
  .buttons .draw::after {
    border: 2px solid transparent;
    width: 0;
    height: 0;
  }
  .buttons .draw::before {
    top: 0;
    left: 0;
  }
  .buttons .draw::after {
    bottom: 0;
    right: 0;
  }
  .buttons .draw:hover {
    color: #0071c5;
    opacity: unset;
  }
  .buttons .draw:hover::before,
  .buttons .draw:hover::after {
    width: 100%;
    height: 100%;
  }
  .buttons .draw:hover::before {
    border-top-color: #0071c5;
    border-right-color: #0071c5;
    transition: width 0.25s ease-out, height 0.25s ease-out 0.25s;
  }
  .buttons .draw:hover::after {
    border-bottom-color: #0071c5;
    border-left-color: #0071c5;
    transition: border-color 0s ease-out 0.5s, width 0.25s ease-out 0.5s, height 0.25s ease-out 0.75s;
  }

  .buttons {
    isolation: isolate;
    width: 100%;
  }
  .btn__final-exam .buttons button {
    color: #FF7675;
    box-shadow: inset 0 0 0 0 #FF7675;
  }
  .btn__final-exam .buttons .draw:hover {
    color: #FF7675;
    opacity: unset;
  }
  .btn__final-exam .buttons .draw:hover::before {
    border-top-color: #FF7675;
    border-right-color: #FF7675;
    transition: width 0.25s ease-out, height 0.25s ease-out 0.25s;
  }
  .btn__final-exam .buttons .draw:hover::after {
    border-bottom-color: #FF7675;
    border-left-color: #FF7675;
    transition: border-color 0s ease-out 0.5s, width 0.25s ease-out 0.5s, height 0.25s ease-out 0.75s;
  }
  /* end button exam */

  /* statistic */
  .content__statistic {
    display: flex;
    column-gap: 10px;
    width: 100%;
  }
  .content__chart {
    width: 50%;
  }
  .content__rank {
    width: 100%;
    height: 400px;
    border-radius: 5px;
    box-shadow: 2px 3px 6px rgba(0, 0, 0, 0.16), 2px 3px 6px rgba(0, 0, 0, 0.23);
  }
  .content__rank h3 {
    font-size: 20px;
    color: #0071c5;
  }
  .content__rank__info {
    height: calc(100% - 61px);
    overflow-y: scroll;
  }
  .content__rank__title {
    display: flex;
    align-items: center;
    column-gap: 10px;
    justify-content: center;
    padding: 10px 0;
    border-bottom: 1px solid #0071c5;
    width: 96%;
    margin: 0 auto;
  }
  .content__rank__title img {
    width: 40px;
    height: 40px;
  }
  .content__rank__inner {
    width: 80%;
    margin: 10px auto 0 auto;
    display: flex;
    align-items: center;
    column-gap: 10px;
  }
  .content__rank__noResult {
    width: 80%;
    margin: 10px auto 0 auto;
    display: flex;
    align-items: center;
    column-gap: 10px;
    position: relative;
    height: calc(100% - 71px);
  }
  .content__rank__noResult img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100px;
    height: 100px;
  }
  .content__rank__icon {
    width: 40px;
    height: 40px;
  }
  .content__rank__icon img {
    width: 100%;
    height: 100%;
  }
  .content__rank__icon p {
    font-size: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    color: #0071c5;
    font-weight: 700;
    text-transform: uppercase;
  }
  .content__rank__name {
    width: calc(100% - 160px);
  }
  .content__rank__name p {
    font-size: 15px;
    font-weight: 400;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    line-clamp: 1;
    -webkit-line-clamp: 1;
  }
  .content__rank__score {
    width: 100px;
  }
  .content__rank__score p {
    color: #FF7675;
    font-size: 15px;
    font-weight: 600;
    text-align: center;
  }
  /* end statistic */

  /* mobile */
  .mb .content {
    flex-direction: column-reverse;
    height: auto;
    width: 100%;
  }
  .mb .curr-exam__content__item {
    width: 100%;
  }
  .mb .curr-exam__progress {
    width: 50%;
  }
  .mb .content__statistic {
    width: 100%;
    height: 300px;
  }
  .mb .content__rank {
    width: 100%;
    height: 300px;
  }
  .mb .content__rank__inner {
    width: 97%;
  }
  .mb .buttons button {
    box-shadow: inset 0 0 0 0 #000;
    text-align: left;
    border-radius: 0;
    padding: 5px 10px;
  }
  .mb .curr-exam__name {
    width: calc(100% - 90px);
  }
  .mb .buttons .draw p {
    width: 230px;
  }
  .mb .title__btn--left {
    display: flex;
  }
  /* end mobile */
  .nqt_hid {
    margin-bottom: 10px !important;
    margin-top: 15px !important;
  }
  .title_mb {
    width: calc(100% - 160px);
    position: fixed;
    font-weight: bold;
    top: 0;
    left: 48px;
    z-index: 1000;
    background-color: #0071c5;
    height: 60px;
    color: #fff;
    font-size: 13px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    line-height: 60px !important;
    padding-left: 2px;
  }
  .detail-content.mb {
    height: calc(100vh - 160px);
  }
  .disable:hover {
    cursor: context-menu;
  }

  .title__exam {
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
  }
  .title__exam h2 {
    font-size: 23px;
    color: #0071c5;
  }
  .title__exam .title__btn--right {
    display: flex;
    column-gap: 20px;
  }
  .title__btn--right img {
    margin: 0 auto;
  }
  .title {
    display: flex;
    height: auto;
  }
  .title img {
    width: 40px;
    margin-bottom: 3px;
  }
  .title span {
    font-size: 24px;
    align-items: center;
    cursor: pointer;
    font-weight: 700;
    display: flex;
    padding-left: 10px;
  }

  .item {
    margin-top: 0px;
    margin-right: 0px;
    margin-left: 0px;
  }
</style>
<style>
  .class1 {
    border-radius: 10px;
    color: white;
    background-color: rgba(31, 30, 30, 0.9);
  }
  .el-timeline-item__content {
    color: white;
  }
  .el-dialog__title {
    color: white;
  }
  .btn-custom-cancel {
    float: right;
    margin-left: 10px;
    margin-top: 2px;
  }
  .primarylists .titles .title {
    text-transform: none !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/curriculum/curriculumExam.vue